import { Box, Paper, Stack, Typography } from '@mui/material';

export function EmptyStateInfoCard({
    icon,
    title,
    description,
}) {
    return (
        <Paper
            sx={{
                textAlign: 'center',
                mx: 'auto',
                my: 2,
                p: { xs: 2, sm: 3 },
                maxWidth: 560,
            }}
            elevation={0}
        >
            <Stack spacing={2} alignItems="center">
                <Box aria-hidden="true" sx={{ fontSize: 56, lineHeight: 0 }}>
                    {icon}
                </Box>
                <Typography variant="h6">{title}</Typography>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ whiteSpace: 'pre-line' }}
                >
                    {description}
                </Typography>
            </Stack>
        </Paper>
    );
}